import {Biotwin} from '../types';
import {DefinitionList} from '../../../app/components/DefinitionList';
const dateTimeFormatOptions = {
  dateStyle: 'short',
  timeStyle: 'short',
} as const;
export interface BiotwinInfoProps {
  biotwin: Biotwin;
}
export const BiotwinInfo = ({biotwin}: BiotwinInfoProps) => {
  return (
    <div>
      <h6 className={'text-base mt-0 mb-6'}>{biotwin.name}</h6>
      <DefinitionList
        items={[
          {
            description: biotwin.createdByUserName,
            icon: 'user-plus',
            term: 'Created By',
          },
          {
            description: new Date(biotwin.createdAt).toLocaleString(undefined, dateTimeFormatOptions),
            icon: 'calendar-plus',
            term: 'Created At',
          },
          {
            description: biotwin.modifiedByUserName,
            icon: 'user',
            term: 'Last Modified By',
          },
          {
            description: new Date(biotwin.modifiedAt).toLocaleString(undefined, dateTimeFormatOptions),
            icon: 'calendar',
            term: 'Last Modified At',
          },
        ]}
      />
    </div>
  );
};
